import Navbar from "./components/Navbar";
import Overview from "./components/Overview";
import TransportRoutes from "./components/TransportRoutes";
import Contracts from "./components/Contracts";
import Profitability from "./components/Profitability";
import MarketAnalysis from "./components/MarketAnalysis";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="bg-[#0b0b0b] min-h-screen font-sans">
      <Navbar />
      <Overview />
      <TransportRoutes />
      <Contracts />
      <Profitability />
      <MarketAnalysis />
      <Contact />
      <Footer />
    </div>
  );
}
